import { inject } from 'mobx-react';
import * as React from 'react';

import { Layer } from 'bernie-view';
import { QueryRoute, RouteStore } from 'bernie-core';

import { PropertySummary } from '@shared-ui/lodging-property-details';

import { CurrentHotelStore } from 'src/common/stores/current-hotel-store';
import { usePropertyListing } from 'src/common/stores/contexts';

import { SharedUiMap } from 'src/common/components/infosite/shared-ui/details/map-wrapper';
import { SharedUiPropertyReviewsDialog } from '../reviews/shared-ui-property-reviews-dialog';
import { SharedUiWrapperProps, withSharedUiPropertyDetails } from './shared-ui-property-details';

interface SummaryWrapperProps extends SharedUiWrapperProps {
  routeStore?: RouteStore;
}

const SummaryWrapper: React.FC<SummaryWrapperProps> = inject('routeStore')(
  React.memo(({ inputs, routeStore }) => {
    /* istanbul ignore next */
    const onClickMap = React.useCallback(() => routeStore?.updateSearch({ pwaDialog: 'map' }), [routeStore]);

    /* istanbul ignore next */
    const onClickReviews = React.useCallback(() => routeStore?.updateSearch({ pwaDialog: 'reviews' }), [routeStore]);

    const { getSummaryPlaceholderData } = usePropertyListing();

    return (
      <>
        <PropertySummary
          onClickReviews={onClickReviews}
          onClickMap={onClickMap}
          inputs={inputs}
          placeholderData={getSummaryPlaceholderData?.()}
        />
        <MapDialogWrapper />
        <ReviewsDialogWrapper />
      </>
    );
  })
);

interface SummaryDialogProps {
  currentHotel?: CurrentHotelStore;
  routeStore?: RouteStore;
}

const ReviewsDialogWrapper: React.FC<Pick<SummaryDialogProps, 'routeStore'>> = inject('routeStore')(({ routeStore }) => {
  /* istanbul ignore next */
  const onCloseDialog = React.useCallback(() => routeStore?.goBack(), [routeStore]);

  return (
    <QueryRoute query={{ pwaDialog: 'reviews' }}>
      <SharedUiPropertyReviewsDialog onDialogClose={onCloseDialog} />
    </QueryRoute>
  );
});
ReviewsDialogWrapper.displayName = 'ReviewsDialogWrapper';

const MapDialogWrapper: React.FC<SummaryDialogProps> = inject('routeStore')(({ routeStore }) => {
  /* istanbul ignore next */
  const onCloseDialog = React.useCallback(() => routeStore?.goBack(), [routeStore]);

  return (
    <QueryRoute query={{ pwaDialog: 'map' }}>
      <Layer id="infosite-map" onDismiss={onCloseDialog}>
        <SharedUiMap onClose={onCloseDialog} />
      </Layer>
    </QueryRoute>
  );
});
MapDialogWrapper.displayName = 'MapDialogWrapper';

export const SharedUiSummaryWrapper = withSharedUiPropertyDetails<SharedUiWrapperProps>(SummaryWrapper);
SharedUiSummaryWrapper.displayName = 'SharedUiSummaryWrapper';
